<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}一物一码
        </div>
        <div class="fr">
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="(barcodeSave && formData.id == null) || (barcodeEdit && formData.id != null)"
                     @click="saveData">保存
          </el-button>
        </div>
      </div>
      <div>
        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>配件信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  配件条码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.partsBarcode" clearable/>
                </td>
                <th>
                  配件编码
                </th>
                <td>
                  <el-input type="text"
                            autocomplete="off"
                            v-model="formData.partsCode"
                            @focus="showPartsPop=true"
                            :clearable="true"
                            @clear="() => {formData.partsName = null}"
                  >
                    <i slot="suffix" class="el-input__icon el-icon-search"
                       @click="showPartsPop=true"></i>
                  </el-input>
<!--                  <el-input type="text" autocomplete="off" v-model="formData.partsCode" clearable/>-->
                </td>
                <th>
                  配件名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" :disabled="true" v-model="formData.partsName" clearable/>
                </td>
                <th>
                  安装时间
                </th>
                <td>
                  <el-date-picker type="datetime" placeholder="选择日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                                  v-model="formData.instDate" clearable/>
                </td>
              </tr>
              <tr>

                <th>
                  供应商编码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.supplierCode" clearable/>
                </td>
                <th>
                  供应商名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.supplierName" clearable/>
                </td>
                <th>
                  生产批次
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.supplierProduceNo" clearable/>
                </td>
                <th>
                  序列号
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.produceNoSeq" clearable/>
                </td>
              </tr>
              <tr>
                <th>
                  模式
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.produceModel" clearable/>
                </td>
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="d-item">
            <div class="title first"><b>产品信息</b></div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  产品条码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.itemBarcode" clearable/>
                </td>
                <th>
                  产品编码
                </th>
                <td>
                  <el-input type="text"
                            autocomplete="off"
                            v-model="formData.itemCode"
                            @focus="showItemPop=true"
                            :clearable="true"
                            @clear="() => {formData.itemName = null}"
                  >
                    <i slot="suffix" class="el-input__icon el-icon-search"
                       @click="showItemPop=true"></i>
                  </el-input>
                  <!--                  <el-input type="text" autocomplete="off" v-model="formData.itemCode" clearable/>-->
                </td>
                <th>
                  产品名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.itemName" :disabled="true" clearable/>
                </td>

              </tr>
              <tr>
                <th>
                  制造商
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.produceCompany" clearable/>
                </td>
                <th>
                  生产批次
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.produceNo" clearable/>
                </td>
                <th>
                  产线
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.produceLine" clearable/>
                </td>
              </tr>

              </tbody>
            </table>
          </div>
        </div>

      </div>
    </el-form>

    <item-dialog :visiable.sync="showItemPop"
                 v-if="showItemPop"
                 @commitSelectedRow="commitSelectedRow"
                 multi="true"
                 :param="{indexNum: null, partsCode: formData.partsCode}"
    />

    <parts-dialog :visiable.sync="showPartsPop"
                  v-if="showPartsPop"
                  @commitSelectedRow="commitSelectedPartsRow"
    />
  </div>
</template>
<script>
import itemDialog from '@/views/dialogCommon/itemDialog';
import partsDialog from '@/views/dialogCommon/radioPartsDialog.vue';
import Tinymce from '@/components/Tinymce';
import {editPageMixins} from "@/mixins/tabChang"
import api from "@/api/projectApi";
import {mapGetters} from "vuex";

export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    partsDialog,
    Tinymce, itemDialog
  },
  watch: {},
  data() {
    return {
      barcodeSave: false,
      barcodeEdit: false,
      isEdit: false,
      dataId: 0,
      formData: {
        id: null,
        partsBarcode: null,  // 配件条码
        partsCode: null,  // 配件编码
        partsName: null,  // 配件名称
        instDate: null,  // 安装时间
        supplierCode: null,  // 供应商编码
        supplierName: null,  // 供应商名称
        supplierProduceNo: null,  // 生产批次
        produceNoSeq: null,  // 序列号
        produceModel: null,  // 模式
        itemBarcode: null,  // 产品条码
        itemCode: null,  // 产品编码
        itemName: null,  // 产品名称
        produceCompany: null,  // 制造商
        produceNo: null,  // 生产批次
        produceLine: null,  // 产线
      },
      showItemPop: false,
      showPartsPop: false,
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.barcodeSave = this.permissions['parts_barcode_add']
    this.barcodeEdit = this.permissions['parts_barcode_edit']

    if (this._dataId && !isNaN(this._dataId)) {
      this.dataId = this._dataId;
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    commitSelectedRow(data) {
      console.log(data, '产品弹框选中')
      this.formData.itemCode = data.code
      this.formData.itemName = data.name
    },

    commitSelectedPartsRow(data) {
      console.log('配件弹框选中', data)
      this.formData.partsCode = data.partsCode
      this.formData.partsName = data.partsName
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true
        this.$http.post(api.basPartsBarcode.getDataUrl, {id: this.dataId}).then(response => {
          this.formData = response.data.data
        })
      }
    },

    saveData() {
      let rules = {
        partsBarcode: [{prop: '配件条码', required: true, type: 'string', maxlength: 50}],
        partsCode: [{prop: '配件编码', required: false, type: 'string', maxlength: 20}],
        partsName: [{prop: '配件名称', required: false, type: 'string', maxlength: 50}],
        instDate: [{prop: '安装时间', required: false}],
        supplierCode: [{prop: '供应商编码', required: false, type: 'string', maxlength: 20}],
        supplierName: [{prop: '供应商名称', required: false, type: 'string', maxlength: 50}],
        supplierProduceNo: [{prop: '生产批次', required: false, type: 'string', maxlength: 50}],
        produceNoSeq: [{prop: '序列号', required: false, type: 'string', maxlength: 50}],
        produceModel: [{prop: '模式', required: false, type: 'string', maxlength: 40}],
        itemBarcode: [{prop: '产品条码', required: false, type: 'string', maxlength: 40}],
        itemCode: [{prop: '产品编码', required: false, type: 'string', maxlength: 20}],
        itemName: [{prop: '产品名称', required: false, type: 'string', maxlength: 40}],
        produceCompany: [{prop: '制造商', required: false, type: 'string', maxlength: 40}],
        produceNo: [{prop: '生产批次', required: false, type: 'string', maxlength: 40}],
        produceLine: [{prop: '产线', required: false, type: 'string', maxlength: 40}],
      }

      this.$validate(this.formData, rules).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()

          this.$http.post(api.basPartsBarcode.saveOrUpdateUrl, this.formData).then(() => {
            this.$message.success("保存成功！");
            this.goBackIndex()
            this.$mask.close()

          }).catch(e => {
            console.error(e)
            this.$message.error("保存失败！");
            this.$mask.close()

          })
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}
</style>
